import getConfig from 'next/config';

export const B2cAndWebFavicons = () => {
    const { publicRuntimeConfig } = getConfig();
    const cdnUrl = publicRuntimeConfig.cdnUrl;
    const faviconsBaseUrl = `${cdnUrl}/favicons`;

    return (
        <>
            <link rel="icon" type="image/png" sizes="16x16" href={`${faviconsBaseUrl}/favicon-16x16.png`} />
            <link rel="icon" type="image/png" sizes="32x32" href={`${faviconsBaseUrl}/favicon-32x32.png`} />
            <link rel="icon" type="image/png" sizes="96x96" href={`${faviconsBaseUrl}/favicon-96x96.png`} />
            <link rel="icon" href={`${faviconsBaseUrl}/favicon.ico`} sizes="any" />
            <link rel="icon" type="image/png" sizes="36x36" href={`${faviconsBaseUrl}/android-icon-36x36.png`} />
            <link rel="icon" type="image/png" sizes="48x48" href={`${faviconsBaseUrl}/android-icon-48x48.png`} />
            <link rel="icon" type="image/png" sizes="72x72" href={`${faviconsBaseUrl}/android-icon-72x72.png`} />
            <link rel="icon" type="image/png" sizes="96x96" href={`${faviconsBaseUrl}/android-icon-96x96.png`} />
            <link rel="icon" type="image/png" sizes="144x144" href={`${faviconsBaseUrl}/android-icon-144x144.png`} />
            <link rel="icon" type="image/png" sizes="192x192" href={`${faviconsBaseUrl}/android-icon-192x192.png`} />
            <link rel="apple-touch-icon" href={`${faviconsBaseUrl}/apple-touch-icon.png`} />
            <link rel="apple-touch-icon" sizes="57x57" href={`${faviconsBaseUrl}/apple-icon-57x57.png`} />
            <link rel="apple-touch-icon" sizes="60x60" href={`${faviconsBaseUrl}/apple-icon-60x60.png`} />
            <link rel="apple-touch-icon" sizes="72x72" href={`${faviconsBaseUrl}/apple-icon-72x72.png`} />
            <link rel="apple-touch-icon" sizes="76x76" href={`${faviconsBaseUrl}/apple-icon-76x76.png`} />
            <link rel="apple-touch-icon" sizes="114x114" href={`${faviconsBaseUrl}/apple-icon-114x114.png`} />
            <link rel="apple-touch-icon" sizes="120x120" href={`${faviconsBaseUrl}/apple-icon-120x120.png`} />
            <link rel="apple-touch-icon" sizes="144x144" href={`${faviconsBaseUrl}/apple-icon-144x144.png`} />
            <link rel="apple-touch-icon" sizes="152x152" href={`${faviconsBaseUrl}/apple-icon-152x152.png`} />
            <link rel="apple-touch-icon" sizes="180x180" href={`${faviconsBaseUrl}/apple-icon-180x180.png`} />
            <link rel="apple-touch-icon-precomposed" href={`${faviconsBaseUrl}/apple-icon-precomposed.png`} />
            <link rel="mask-icon" href={`${faviconsBaseUrl}/safari-pinned-tab.svg`} color="#5bbad5" />
            <link rel="manifest" href={`${faviconsBaseUrl}/site.webmanifest`} />
            <meta name="msapplication-config" content={`${faviconsBaseUrl}/browserconfig.xml`} />
            <meta name="msapplication-TileImage" content={`${faviconsBaseUrl}/mstile-150x150.png`} />
        </>
    );
};
